var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail1B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 0H0V225H328V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4199 18.0435H8.60657V22.7704H56.4199V18.0435Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.584 18.0435H113.771V22.7704H161.584V18.0435Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.99 18.0435H61.1769V22.7704H108.99V18.0435Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.154 18.0435H166.34V22.7704H214.154V18.0435Z",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1079 8.58936H8.60657V13.3163H85.1079V8.58936Z",
    fill: "#E0E0E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 30.3325H8.60657V32.2233H319.394V30.3325Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6707 41.6782H8.60657V46.405H94.6707V41.6782Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.459 41.6782H99.427V46.405H142.459V41.6782Z",
    fill: "#E0E0E0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M190.272 41.6782H147.24V46.405H190.272V41.6782Z",
    fill: "#E0E0E0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 63.5137H8.60657V71.1666H29.6445V63.5137Z",
    stroke: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 132.388H8.60657V140.041H29.6445V132.388Z",
    stroke: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 55.8584H8.60657V63.5114H29.6445V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 71.1655H8.60657V78.8184H29.6445V71.1655Z",
    stroke: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 140.045H8.60657V147.697H29.6445V140.045Z",
    stroke: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 78.8179H8.60657V86.4707H29.6445V78.8179Z",
    stroke: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 147.694H8.60657V155.347H29.6445V147.694Z",
    stroke: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 86.4736H8.60657V94.1266H29.6445V86.4736Z",
    stroke: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 109.429H8.60657V117.082H29.6445V109.429Z",
    stroke: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 94.125H8.60657V101.778H29.6445V94.125Z",
    stroke: "#CCCCCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 117.083H8.60657V124.736H29.6445V117.083Z",
    stroke: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 101.776H8.60657V109.429H29.6445V101.776Z",
    stroke: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 124.736H8.60657V132.389H29.6445V124.736Z",
    stroke: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 63.5137H117.62V71.1666H150.134V63.5137Z",
    stroke: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 132.388H117.62V140.041H150.134V132.388Z",
    stroke: "#CCCCCC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 55.8584H117.62V63.5114H150.134V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 71.1655H117.62V78.8184H150.134V71.1655Z",
    stroke: "#CCCCCC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 140.045H117.62V147.697H150.134V140.045Z",
    stroke: "#CCCCCC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 78.8179H117.62V86.4707H150.134V78.8179Z",
    stroke: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 147.694H117.62V155.347H150.134V147.694Z",
    stroke: "#CCCCCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 86.4736H117.62V94.1266H150.134V86.4736Z",
    stroke: "#CCCCCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 109.429H117.62V117.082H150.134V109.429Z",
    stroke: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 94.125H117.62V101.778H150.134V94.125Z",
    stroke: "#CCCCCC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 117.083H117.62V124.736H150.134V117.083Z",
    stroke: "#CCCCCC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 101.776H117.62V109.429H150.134V101.776Z",
    stroke: "#CCCCCC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 124.736H117.62V132.389H150.134V124.736Z",
    stroke: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 63.5137H150.134V71.1666H173.084V63.5137Z",
    stroke: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 132.388H150.134V140.041H173.084V132.388Z",
    stroke: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 55.8584H150.134V63.5114H173.084V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 71.1655H150.134V78.8184H173.084V71.1655Z",
    stroke: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 140.045H150.134V147.697H173.084V140.045Z",
    stroke: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 78.8179H150.134V86.4707H173.084V78.8179Z",
    stroke: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 147.694H150.134V155.347H173.084V147.694Z",
    stroke: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 86.4736H150.134V94.1266H173.084V86.4736Z",
    stroke: "#CCCCCC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 109.429H150.134V117.082H173.084V109.429Z",
    stroke: "#CCCCCC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 94.125H150.134V101.778H173.084V94.125Z",
    stroke: "#CCCCCC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 117.083H150.134V124.736H173.084V117.083Z",
    stroke: "#CCCCCC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 101.776H150.134V109.429H173.084V101.776Z",
    stroke: "#CCCCCC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 124.736H150.134V132.389H173.084V124.736Z",
    stroke: "#CCCCCC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 63.5137H173.084V71.1666H200.816V63.5137Z",
    stroke: "#CCCCCC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 132.388H173.084V140.041H200.816V132.388Z",
    stroke: "#CCCCCC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 55.8584H173.084V63.5114H200.816V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 71.1655H173.084V78.8184H200.816V71.1655Z",
    stroke: "#CCCCCC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 140.045H173.084V147.697H200.816V140.045Z",
    stroke: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 78.8179H173.084V86.4707H200.816V78.8179Z",
    stroke: "#CCCCCC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 147.694H173.084V155.347H200.816V147.694Z",
    stroke: "#CCCCCC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 86.4736H173.084V94.1266H200.816V86.4736Z",
    stroke: "#CCCCCC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 109.429H173.084V117.082H200.816V109.429Z",
    stroke: "#CCCCCC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 94.125H173.084V101.778H200.816V94.125Z",
    stroke: "#CCCCCC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 117.083H173.084V124.736H200.816V117.083Z",
    stroke: "#CCCCCC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 101.776H173.084V109.429H200.816V101.776Z",
    stroke: "#CCCCCC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 124.736H173.084V132.389H200.816V124.736Z",
    stroke: "#CCCCCC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 63.5137H200.816V71.1666H296.443V63.5137Z",
    stroke: "#CCCCCC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 132.388H200.816V140.041H296.443V132.388Z",
    stroke: "#CCCCCC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 55.8584H200.816V63.5114H296.443V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 71.1655H200.816V78.8184H296.443V71.1655Z",
    stroke: "#CCCCCC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 140.045H200.816V147.697H296.443V140.045Z",
    stroke: "#CCCCCC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 78.8179H200.816V86.4707H296.443V78.8179Z",
    stroke: "#CCCCCC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 147.694H200.816V155.347H296.443V147.694Z",
    stroke: "#CCCCCC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 86.4736H200.816V94.1266H296.443V86.4736Z",
    stroke: "#CCCCCC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 109.429H200.816V117.082H296.443V109.429Z",
    stroke: "#CCCCCC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 94.125H200.816V101.778H296.443V94.125Z",
    stroke: "#CCCCCC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 117.083H200.816V124.736H296.443V117.083Z",
    stroke: "#CCCCCC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 101.776H200.816V109.429H296.443V101.776Z",
    stroke: "#CCCCCC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 124.736H200.816V132.389H296.443V124.736Z",
    stroke: "#CCCCCC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 63.5137H296.443V71.1666H319.394V63.5137Z",
    stroke: "#CCCCCC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 132.388H296.443V140.041H319.394V132.388Z",
    stroke: "#CCCCCC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 55.8584H296.443V63.5114H319.394V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 71.1655H296.443V78.8184H319.394V71.1655Z",
    stroke: "#CCCCCC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 140.045H296.443V147.697H319.394V140.045Z",
    stroke: "#CCCCCC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 78.8179H296.443V86.4707H319.394V78.8179Z",
    stroke: "#CCCCCC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 147.694H296.443V155.347H319.394V147.694Z",
    stroke: "#CCCCCC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 86.4736H296.443V94.1266H319.394V86.4736Z",
    stroke: "#CCCCCC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 109.429H296.443V117.082H319.394V109.429Z",
    stroke: "#CCCCCC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 94.125H296.443V101.778H319.394V94.125Z",
    stroke: "#CCCCCC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 117.083H296.443V124.736H319.394V117.083Z",
    stroke: "#CCCCCC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 101.776H296.443V109.429H319.394V101.776Z",
    stroke: "#CCCCCC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 124.736H296.443V132.389H319.394V124.736Z",
    stroke: "#CCCCCC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 63.5137H29.644V71.1666H117.62V63.5137Z",
    stroke: "#CCCCCC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 132.388H29.644V140.041H117.62V132.388Z",
    stroke: "#CCCCCC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 55.8584H29.644V63.5114H117.62V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 71.1655H29.644V78.8184H117.62V71.1655Z",
    stroke: "#CCCCCC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 140.045H29.644V147.697H117.62V140.045Z",
    stroke: "#CCCCCC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 78.8179H29.644V86.4707H117.62V78.8179Z",
    stroke: "#CCCCCC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 147.694H29.644V155.347H117.62V147.694Z",
    stroke: "#CCCCCC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 86.4736H29.644V94.1266H117.62V86.4736Z",
    stroke: "#CCCCCC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 109.429H29.644V117.082H117.62V109.429Z",
    stroke: "#CCCCCC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 94.125H29.644V101.778H117.62V94.125Z",
    stroke: "#CCCCCC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 117.083H29.644V124.736H117.62V117.083Z",
    stroke: "#CCCCCC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 101.776H29.644V109.429H117.62V101.776Z",
    stroke: "#CCCCCC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 124.736H29.644V132.389H117.62V124.736Z",
    stroke: "#CCCCCC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 163.002H8.60657V216.573H319.394V163.002Z",
    stroke: "#CCCCCC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 155.346H8.60657V162.999H319.394V155.346Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2453 167.784H13.3882V211.789H60.2453V167.784Z",
    fill: "#EAEAEA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M110.927 167.784H64.0695V211.789H110.927V167.784Z",
    fill: "#EAEAEA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M161.609 167.784H115.708V211.789H161.609V167.784Z",
    fill: "#EAEAEA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M212.291 167.784H166.39V211.789H212.291V167.784Z",
    fill: "#EAEAEA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M263.93 167.784H217.073V211.789H263.93V167.784Z",
    fill: "#EAEAEA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M314.612 167.784H267.755V211.789H314.612V167.784Z",
    fill: "#EAEAEA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9014 184.405C45.9014 183.432 45.0797 182.611 44.1084 182.611H40.8213L40.3357 181.415C40.0741 180.706 39.4018 180.219 38.6547 180.219H33.9854C33.2383 180.219 32.566 180.706 32.3044 181.415L31.8562 182.611H28.5691C27.5605 182.611 26.7761 183.432 26.7761 184.405V195.167C26.7761 196.175 27.5605 196.96 28.5691 196.96H44.1084C45.0797 196.96 45.9014 196.175 45.9014 195.167V184.405ZM40.8213 189.785C40.8213 192.289 38.8041 194.269 36.3387 194.269C33.836 194.269 31.8562 192.289 31.8562 189.785C31.8562 187.319 33.836 185.302 36.3387 185.302C38.8041 185.302 40.8213 187.319 40.8213 189.785ZM39.6259 189.785C39.6259 187.991 38.1318 186.496 36.3387 186.496C34.5083 186.496 33.0516 187.991 33.0516 189.785C33.0516 191.617 34.5083 193.073 36.3387 193.073C38.1318 193.073 39.6259 191.617 39.6259 189.785Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5826 184.405C96.5826 183.432 95.7617 182.611 94.7901 182.611H91.5028L91.0172 181.415C90.7558 180.706 90.0834 180.219 89.3363 180.219H84.6671C83.9199 180.219 83.2475 180.706 82.9861 181.415L82.5377 182.611H79.2506C78.2421 182.611 77.4576 183.432 77.4576 184.405V195.167C77.4576 196.175 78.2421 196.96 79.2506 196.96H94.7901C95.7617 196.96 96.5826 196.175 96.5826 195.167V184.405ZM91.5028 189.785C91.5028 192.289 89.4857 194.269 87.0204 194.269C84.5176 194.269 82.5377 192.289 82.5377 189.785C82.5377 187.319 84.5176 185.302 87.0204 185.302C89.4857 185.302 91.5028 187.319 91.5028 189.785ZM90.3075 189.785C90.3075 187.991 88.8133 186.496 87.0204 186.496C85.19 186.496 83.7331 187.991 83.7331 189.785C83.7331 191.617 85.19 193.073 87.0204 193.073C88.8133 193.073 90.3075 191.617 90.3075 189.785Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 184.405C148.222 183.432 147.401 182.611 146.429 182.611H143.142L142.656 181.415C142.394 180.706 141.723 180.219 140.975 180.219H136.306C135.559 180.219 134.886 180.706 134.625 181.415L134.178 182.611H130.889C129.881 182.611 129.096 183.432 129.096 184.405V195.167C129.096 196.175 129.881 196.96 130.889 196.96H146.429C147.401 196.96 148.222 196.175 148.222 195.167V184.405ZM143.142 189.785C143.142 192.289 141.125 194.269 138.659 194.269C136.157 194.269 134.178 192.289 134.178 189.785C134.178 187.319 136.157 185.302 138.659 185.302C141.125 185.302 143.142 187.319 143.142 189.785ZM141.948 189.785C141.948 187.991 140.452 186.496 138.659 186.496C136.828 186.496 135.373 187.991 135.373 189.785C135.373 191.617 136.828 193.073 138.659 193.073C140.452 193.073 141.948 191.617 141.948 189.785Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M198.903 184.405C198.903 183.432 198.082 182.611 197.11 182.611H193.823L193.339 181.415C193.077 180.706 192.403 180.219 191.657 180.219H186.988C186.24 180.219 185.569 180.706 185.307 181.415L184.858 182.611H181.571C180.562 182.611 179.778 183.432 179.778 184.405V195.167C179.778 196.175 180.562 196.96 181.571 196.96H197.11C198.082 196.96 198.903 196.175 198.903 195.167V184.405ZM193.823 189.785C193.823 192.289 191.806 194.269 189.341 194.269C186.838 194.269 184.858 192.289 184.858 189.785C184.858 187.319 186.838 185.302 189.341 185.302C191.806 185.302 193.823 187.319 193.823 189.785ZM192.628 189.785C192.628 187.991 191.134 186.496 189.341 186.496C187.511 186.496 186.053 187.991 186.053 189.785C186.053 191.617 187.511 193.073 189.341 193.073C191.134 193.073 192.628 191.617 192.628 189.785Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M249.586 184.405C249.586 183.432 248.764 182.611 247.793 182.611H244.507L244.02 181.415C243.758 180.706 243.086 180.219 242.339 180.219H237.669C236.923 180.219 236.251 180.706 235.989 181.415L235.541 182.611H232.253C231.245 182.611 230.461 183.432 230.461 184.405V195.167C230.461 196.175 231.245 196.96 232.253 196.96H247.793C248.764 196.96 249.586 196.175 249.586 195.167V184.405ZM244.507 189.785C244.507 192.289 242.488 194.269 240.023 194.269C237.521 194.269 235.541 192.289 235.541 189.785C235.541 187.319 237.521 185.302 240.023 185.302C242.488 185.302 244.507 187.319 244.507 189.785ZM243.311 189.785C243.311 187.991 241.816 186.496 240.023 186.496C238.192 186.496 236.737 187.991 236.737 189.785C236.737 191.617 238.192 193.073 240.023 193.073C241.816 193.073 243.311 191.617 243.311 189.785Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M300.269 184.405C300.269 183.432 299.447 182.611 298.475 182.611H295.187L294.703 181.415C294.441 180.706 293.769 180.219 293.022 180.219H288.353C287.605 180.219 286.934 180.706 286.671 181.415L286.223 182.611H282.936C281.927 182.611 281.144 183.432 281.144 184.405V195.167C281.144 196.175 281.927 196.96 282.936 196.96H298.475C299.447 196.96 300.269 196.175 300.269 195.167V184.405ZM295.187 189.785C295.187 192.289 293.171 194.269 290.706 194.269C288.203 194.269 286.223 192.289 286.223 189.785C286.223 187.319 288.203 185.302 290.706 185.302C293.171 185.302 295.187 187.319 295.187 189.785ZM293.993 189.785C293.993 187.991 292.5 186.496 290.706 186.496C288.875 186.496 287.417 187.991 287.417 189.785C287.417 191.617 288.875 193.073 290.706 193.073C292.5 193.073 293.993 191.617 293.993 189.785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail1B);
export default __webpack_public_path__ + "static/media/thumbnail-1-b.215faa0c1ee9b2301d99a21df0a0bef7.svg";
export { ForwardRef as ReactComponent };